/**
 * Wires the host into the SDK's embeddable-component registry: registers
 * PluginEmbedHost as the renderer and (re)publishes each plugin's
 * embeddable components when the plugin's UI loads.
 */

import { PluginEmbedHost } from '../extension-points/PluginEmbedHost';
import type { BuildEmbeddablesInput } from './build-embeddable-descriptors';
import { buildEmbeddableDescriptors } from './build-embeddable-descriptors';
import { getEmbedSdk } from './sdk-embed';

const generations = new Map<string, number>();

export function installEmbedHost(): boolean {
  const sdk = getEmbedSdk();
  if (!sdk) {
    console.info('[EmbedHost] @neuro/plugin-sdk < 1.4 — embedding plugin components is disabled');
    return false;
  }
  // This host implements version 1 of the embed contract.
  sdk.registry.setHost({ contractVersion: 1, hostName: 'neuro-core', Renderer: PluginEmbedHost });
  return true;
}

export function registerPluginEmbeddables(input: Omit<BuildEmbeddablesInput, 'generation' | 'sdk'>): void {
  const sdk = getEmbedSdk();
  if (!sdk) return;
  const generation = (generations.get(input.pluginId) ?? 0) + 1;
  generations.set(input.pluginId, generation);
  try {
    sdk.registry.replacePlugin(input.pluginId, buildEmbeddableDescriptors({ ...input, generation, sdk }));
  } catch (err) {
    console.warn(`[EmbedHost] Could not register embeddable components for "${input.pluginId}"`, err);
  }
}

export function unregisterPluginEmbeddables(pluginId: string): void {
  getEmbedSdk()?.registry.unregisterPlugin(pluginId);
}
